<label class="container mb-4">
  <input
    type="checkbox"
    [checked]="checked"
    (click)="switch(elementValue)"
    [disabled]="disableCheckbox"
  />
  <span class="checkmark"></span>
</label>
